import { Component, Prop, Vue } from 'vue-property-decorator'
import { MarkingAdInfo } from '~/types/api/MarkingAdTypes'
import s from '~/utils/s'

@Component
export default class MarkingAd extends Vue {
  @Prop({ required: false, type: Object })
  info!: MarkingAdInfo

  render () {
    if (this.info) {
      return (
        <div class="marking-ad__wrapper">
          <div class="marking-ad__pop">
            Реклама
          </div>
          <div class="marking-ad__text">
            <div class="marking-ad__advertiser">
              <div class="marking-ad__advertiser-name">
                <b class="marking-ad__bold">Рекламодатель:  </b>{this.info.clientName},
              </div>
              <a href={this.info.advertiserUrl} class="marking-ad__advertiser-url">
                {this.info.advertiserUrl}
              </a>
            </div>
            <div class="marking-ad__erid">
              <b class="marking-ad__bold">ID рекламы: </b>{this.info.creativeToken}
            </div>
          </div>
        </div>
      )
    }
  }
}
